















import { Component, Mixins, VModel } from 'vue-property-decorator';

import ModelSetter from "../../../../../../Mixins/ModelSetter";
import WeekDayPickerInput from '../../../../../../components/Pi/fields/WeekDayPickerInput/WeekDayPickerInput.vue';
import { DayOfWeek } from "./DayOfWeek";

@Component({
  components: {
    WeekDayPickerInput
  }
})
export default class TimeIntervalSetting extends Mixins(ModelSetter) {
  @VModel() model!: DayOfWeek

  get values() {
    return this.model.values.map(v => +v)
  }

  set values(values: Array<number>) {
    this.model.values = values.map(v => v.toString())
  }
}
